import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../lib/analytics'

/**
 * Custom hook to automatically track page views when route changes
 */
export function usePageTracking(): void {
  const location = useLocation()

  useEffect(() => {
    // Get page title from document
    const title = document.title

    // Track page view
    trackPageView({
      path: location.pathname + location.search,
      title,
    })
  }, [location])
}
